<div id="manage-products">
  <app-easykash-add-product></app-easykash-add-product>
  <app-base-report *ngIf="productManagementReportData"
                   [filterFields]="filterField"
                   [hasDateRangeFilter]="true"
                   [hasCheckboxes]="true"
                   [reportName]="reportName"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="productManagementReportData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChance($event)"
                   [tableLoading]="loading"
                   [rowActions]="rowActions"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="getFilteredProductsService"
                   [selectionModel]="selection"
                   [selectionActions]="selectionActions"
                   (rowActionClicked)="rowActionClicked($event)"
                   (selectionActionTrigger)="selectionActionsCB($event)"></app-base-report>
</div>
